export class StorageGateway {
    'dlsgPolicyIds';
    'region';
    'storageGatewayDetails';
    'deletionManifestPath';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlsgPolicyIds",
            "baseName": "dlsgPolicyIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageGatewayDetails",
            "baseName": "storageGatewayDetails",
            "type": "StorageGatewayDetails",
            "format": ""
        },
        {
            "name": "deletionManifestPath",
            "baseName": "deletionManifestPath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StorageGateway.attributeTypeMap;
    }
    constructor() {
    }
}
